module.exports = __webpack_public_path__ + "img/source_01.1b974c0e.png";